import { Controller } from "@hotwired/stimulus"

// Reorders hidden fields for testing_process[test_type_codes][] via drag handle; adds rows from a select.
// Note: dragstart's event.target is the draggable <li>, not the handle — we track pointerdown on the grip.
export default class extends Controller {
  static targets = ["list", "addSelect", "rowTemplate"]

  static values = {
    codeNames: Object,
    fieldName: String
  }

  connect() {
    this.draggedRow = null
    this.dragStartedFromHandle = false
    this.boundListPointerDown = this.onListPointerDown.bind(this)
    this.listTarget.addEventListener("pointerdown", this.boundListPointerDown, true)
    this.syncAddSelect()
  }

  disconnect() {
    this.listTarget.removeEventListener("pointerdown", this.boundListPointerDown, true)
  }

  onListPointerDown(event) {
    if (!event.isPrimary) return
    if (!this.listTarget.contains(event.target)) return
    this.dragStartedFromHandle = Boolean(event.target.closest("[data-drag-handle]"))
  }

  addFromSelect() {
    const select = this.addSelectTarget
    const code = select.value
    if (!code) return

    const li = this.rowTemplateTarget.content.firstElementChild.cloneNode(true)
    const input = li.querySelector("input[type=hidden]")
    const labelEl = li.querySelector("[data-testing-process-tests-order-label-role]")
    input.name = this.fieldNameValue
    input.value = code
    labelEl.textContent = this.codeNamesValue[code] || code

    this.listTarget.appendChild(li)
    select.selectedIndex = 0
    this.syncAddSelect()
  }

  dragStart(event) {
    if (!this.dragStartedFromHandle) {
      event.preventDefault()
      return
    }
    this.dragStartedFromHandle = false

    this.draggedRow = event.currentTarget
    this.draggedRow.classList.add("is-dragging")
    event.dataTransfer.effectAllowed = "move"
    try {
      event.dataTransfer.setData("text/plain", "")
    } catch (_) {
      // IE / legacy
    }
  }

  dragEnd() {
    this.draggedRow?.classList.remove("is-dragging")
    this.draggedRow = null
    this.dragStartedFromHandle = false
  }

  dragEnter(event) {
    event.preventDefault()
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
  }

  drop(event) {
    event.preventDefault()
    const row = event.target.closest(".testing-process-tests-order__item")
    if (!row || !this.listTarget.contains(row) || !this.draggedRow || row === this.draggedRow) return

    const rect = row.getBoundingClientRect()
    const before = event.clientY < rect.top + rect.height / 2
    if (before) {
      this.listTarget.insertBefore(this.draggedRow, row)
    } else {
      this.listTarget.insertBefore(this.draggedRow, row.nextSibling)
    }
  }

  remove(event) {
    event.preventDefault()
    const item = event.currentTarget.closest("li")
    if (!item || !this.listTarget.contains(item)) return
    item.remove()
    this.syncAddSelect()
  }

  syncAddSelect() {
    const selected = new Set()
    this.listTarget.querySelectorAll("input[type=hidden]").forEach((el) => {
      const v = el.value.trim()
      if (v) selected.add(v)
    })

    this.addSelectTarget.querySelectorAll("option").forEach((opt) => {
      if (opt.value === "") {
        opt.disabled = false
        return
      }
      const taken = selected.has(opt.value)
      opt.disabled = taken
      opt.hidden = taken
    })
  }
}
